import styled from "styled-components"

export const SubscribeFormSectionStyles = styled.section`
  background: #3B5CA7;
`
